/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketpageexport2Inputs */

const en_ticketpageexport2 = /** @type {(inputs: Ticketpageexport2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Export CSV`)
};

const de_ticketpageexport2 = /** @type {(inputs: Ticketpageexport2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CSV exportieren`)
};

/**
* | output |
* | --- |
* | "Export CSV" |
*
* @param {Ticketpageexport2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketpageexport2 = /** @type {((inputs?: Ticketpageexport2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketpageexport2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketpageexport2(inputs)
	return de_ticketpageexport2(inputs)
});
export { ticketpageexport2 as "ticketPageExport" }